import React, {Component} from 'react';
import {Button} from "finform";
import {Url} from "finhelper";
import {connect} from "react-redux";
import {Link} from 'react-router-dom';

import {CenteredWrapper, Container} from '#app/pages/styles';
import {Img, ImgContainer, NotFoundContainer, Text, Title} from './styles';
import notFoundImage from './images/swan.png';

class NotFound extends Component {
  constructor(props) {
    super(props);

    this.state = {
      statuses: []
    };
  }

  componentDidMount() {
    // window.scrollTo(0, 0);
  }

  render() {
    let url = Url.getCurrentUrl();

    return (
        <Container style={{
          margin: url.indexOf('/cabinet') !== -1 ? '0 auto' : '20px auto 0 auto'
        }}>
          <CenteredWrapper>
            <NotFoundContainer>
              <ImgContainer>
                <Img src={notFoundImage ?? ''} />
              </ImgContainer>
              <Title>Ничего не найдено</Title>
              <Text>Попробуйте вернуться назад или поищите что-нибудь другое.</Text>
              <Text>Код ошибки: 404</Text>
              <Link to={url.indexOf('/cabinet') !== -1 ? '/cabinet' : '/'}>
                <Button type='link' className='style1'>На главную</Button>
              </Link>
            </NotFoundContainer>
          </CenteredWrapper>
        </Container>
    );
  }
}

const enhance = connect(
    (state) => ({ }),
    {}
);

export default enhance(NotFound);